import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import FinanceProductList from './FinanceProductList';

const FinanceProductListPage = () => {
    const { t } = useTranslation('financeProductList');
    const { permissions: accountPermissions } = useAccount();

    const goToNewFinanceProductPage = useGoTo('/admin/financeProducts/add');

    const extra = hasPermissions(accountPermissions, [permissionKind.createFinanceProduct]) && (
        <Button icon={<PlusOutlined />} onClick={goToNewFinanceProductPage} type="primary">
            {t('financeProductList:actions.newFinanceProduct')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('financeProductList:title')}>
            <FinanceProductList />
        </ConsolePageWithHeader>
    );
};

export default FinanceProductListPage;
